import styled from 'styled-components';
import { maxMobile, secondaryFont, wMBold } from 'Utils/utilsStyle';
import SearchSvg from 'Components/common/assets/svgIcons/SearchSvg';

const Container = styled.div`
  font-weight: 600;
  height: calc(100vh - 272px);
  display:flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: 22px;
  color: #667982;
  font-family: ${secondaryFont};
    @media all and (max-width: ${maxMobile}) {
      font-size: 16px;
      line-height: 18px;
    }
`;

const Text = styled.span`
  .search-text{
    border-bottom: 1px solid #1EC252;
    color: #1EC252;
    font-size: 22px;
    font-weight: ${wMBold};
    font-family: ${secondaryFont};
      @media all and (max-width: ${maxMobile}){
        font-size: 14px;
      }
      .search-svg {
        width: 15px;
        height: 15px;
        @media all and (max-width: ${maxMobile}){
          width: 13px;
          height: 13px;
        }
      }
  }
`;

const ExploreSearches = function ExploreSearches() {
  return (
    <Container>
      <Text>
        Explore our
        {' '}
        <span className="search-text">
          <SearchSvg />
          {' '}
          Search
        </span>
        {' '}
        for more people
      </Text>
    </Container>
  );
};

export default ExploreSearches;
